enum ContextType {
  PLATFORM = "PLATFORM",
  EVENT_SERIES = "EVENT_SERIES",
  REGISTRATION = "REGISTRATION",
  EVENT = "EVENT",
  PROGRAM = "PROGRAM"
}

export default ContextType;
